import { User, WebStorageStateStore } from 'oidc-client-ts';
import {
  REACT_ALBERTA_CA_KEYCLOAK_URL,
  REACT_ALBERTA_CA_KEYCLOAK_REALM,
  REACT_ALBERTA_CA_KEYCLOAK_CLIENT_ID,
} from '../state/configuration';

const url = REACT_ALBERTA_CA_KEYCLOAK_URL;
const realm = REACT_ALBERTA_CA_KEYCLOAK_REALM;

const appUrl = `${window.location.protocol}//${window.location.hostname}${
  window.location.port ? `:${window.location.port}` : ''
}`;

export const goaConfig = {
  extraQueryParams: { kc_idp_hint: 'core' },
  redirect_uri: `${appUrl}/callback`,
  state: 'tecadmin',
  post_logout_redirect_uri: window.location.origin + '/admin',
};

export const albertaCaConfig = {
  extraQueryParams: { kc_idp_hint: 'Alberta.ca' },
  redirect_uri: `${appUrl}/callback`,
  state: 'albertan',
  post_logout_redirect_uri: window.location.origin + '/',
};

export const lawConfig = {
  extraQueryParams: { kc_idp_hint: 'saml' },
  redirect_uri: `${appUrl}/callback`,
  state: 'lawenforcement',
  post_logout_redirect_uri: window.location.origin + '/law',
};

export const oidcConfig = {
  client_id: REACT_ALBERTA_CA_KEYCLOAK_CLIENT_ID,
  redirect_uri: `${appUrl}/callback`,
  authority: `${url}/auth/realms/${realm}`,
  onLoad: 'login-required',
  automaticSilentRenew: false,
  stateStore: new WebStorageStateStore({ store: window.localStorage }),
  post_logout_redirect_uri: window.location.origin + '/',
};
